import AdminSidebar from '../components/admin/AdminSidebar';
import AdminHeader from '../components/admin/AdminHeader';
import AdminPricingComponent from '../components/admin/AdminPricing';
import '../styles/admin.css';

export default function AdminPricing() {
  return (
    <div className="flex min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      <AdminSidebar />
      <div className="flex-1 ml-0">
        <AdminHeader 
          title="Gestion des Tarifs" 
          subtitle="Configurez vos plans tarifaires"
        />
        <AdminPricingComponent />
      </div>
    </div>
  );
}